import React, {useState, useEffect} from "react";

import "./BreadcrumbTrail.css";
import {Breadcrumb} from "./breadcrumb/Breadcrumb";

export const BreadCrumbTrail = ({context, navigateTo}) => {

    const [facilityBreadcrumb, setFacilityBreadcrumb] = useState(null);
    const [topicAreaBreadcrumb, setTopicAreaBreadcrumb] = useState(null);
    const [problemBreadcrumb, setProblemBreadcrumb] = useState(null);
    const [rootCauseBreadcrumb, setRootCauseBreadcrumb] = useState(null);
    const [changeIdeaBreadcrumb, setChangeIdeaBreadCrumb] = useState(null);
    const [PDSABreadcrumb, setPDSABreadcrumb] = useState(null);

    useEffect(() => {
        const breadcrumbs = context.breadcrumbs;
        if (breadcrumbs) {
            if (breadcrumbs.facilityBreadcrumb) {
                setFacilityBreadcrumb({...breadcrumbs.facilityBreadcrumb});
            }

            if (breadcrumbs.topicAreaBreadcrumb) {
                setTopicAreaBreadcrumb({...breadcrumbs.topicAreaBreadcrumb});
            }

            if (breadcrumbs.problemBreadcrumb) {
                setProblemBreadcrumb({...breadcrumbs.problemBreadcrumb});
            }

            if (breadcrumbs.rootCauseBreadcrumb) {
                setRootCauseBreadcrumb({...breadcrumbs.rootCauseBreadcrumb});
            }

            if (breadcrumbs.changeIdeaBreadcrumb) {
                setChangeIdeaBreadCrumb({...breadcrumbs.changeIdeaBreadcrumb});
            }
            if (breadcrumbs.PDSABreadCrumb) {
                setPDSABreadcrumb({...breadcrumbs.PDSABreadCrumb});
            }
        }
    }, [context])

    return (
        <div className="breadcrumb-trail-container">
            {facilityBreadcrumb &&
            <Breadcrumb breadcrumb={facilityBreadcrumb}
                        color="#04B14B"
                        shiftLeftBy={0}
                        zIndex={6}
                        navigateTo={navigateTo}/>}
            {topicAreaBreadcrumb &&
            <Breadcrumb breadcrumb={topicAreaBreadcrumb}
                        color="#C8242C"
                        shiftLeftBy={-20}
                        zIndex={5}
                        navigateTo={navigateTo}/>}
            {problemBreadcrumb &&
            <Breadcrumb breadcrumb={problemBreadcrumb}
                        color="#5C9AD2"
                        shiftLeftBy={-40}
                        zIndex={4}
                        navigateTo={navigateTo}/>}
            {rootCauseBreadcrumb &&
            <Breadcrumb breadcrumb={rootCauseBreadcrumb}
                        color="#A7CE39"
                        shiftLeftBy={-60}
                        zIndex={3}
                        navigateTo={navigateTo}/>}
            {changeIdeaBreadcrumb &&
            <Breadcrumb breadcrumb={changeIdeaBreadcrumb}
                        color="#9A268E"
                        shiftLeftBy={-80}
                        zIndex={2}
                        navigateTo={navigateTo}/>}
            {PDSABreadcrumb &&
            <Breadcrumb breadcrumb={PDSABreadcrumb}
                        color="#14BFDB"
                        shiftLeftBy={-100}
                        zIndex={1}
                        navigateTo={navigateTo}/>}
        </div>
    );
}
